import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../../../commonComponents/forms/FormInput';
import CustomerInfo from './CustomerInfo';
import translate from '../../../commonComponents/translate';
import OrderProp from '../../shop/propTypes/orderProp';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import { OPPORTUNITIES_STATUSES } from '../../opportunities/components/helpers/opportunitiesListHelper';
import { MODE } from './helpers/orderHelper';

function CustomerSection(props) {
  const {
    t,
    order,
    onChange,
    onShippingChange,
    isShippingAddressDifferent,
    onDifferentShippingAddress,
    isOnlyDigitalProducts,
    userTypeNames,
    onCloseAddUser,
    onAddressOpen,
    isOpportunity,
    languages,
    mode,
    isSubscription,
  } = props;

  const statusItems = useMemo(
    () =>
      OPPORTUNITIES_STATUSES.map(s => ({
        id: s.status,
        text: t(s.text),
      })),
    [],
  );

  return (
    <div
      className="m-portlet m-portlet--mobile col-lg-12 col-12"
      id="customerContainer"
    >
      <div className="m-portlet__body row col-12">
        <h4 className="order-card-title">{t('info')}</h4>
        {isOpportunity ? (
          <>
            <FormInput
              id="opportunityName"
              name="opportunityName"
              labelClassName="col-lg-2 col-12 label-customer text-right"
              containerClassName="col-lg-8 col-12 row no-gutters customer-info-correct-mobile"
              label={`${t('opportunity.name')}*`}
              placeholder={t('opportunity.name')}
              groupProps={{
                className: 'row col-12 order-create-content opportunity-name',
              }}
              onChange={onChange('name')}
              value={order?.name || ''}
              className="form-control m-input"
            />
            <FormInput
              id="opportunityStatus"
              name="opportunityStatus"
              labelClassName="col-lg-2 col-12 label-customer text-right"
              containerClassName="col-lg-8 col-12 row no-gutters customer-info-correct-mobile opportunityStatus"
              label={t('shop.order_status')}
              placeholder={t('shop.order_status')}
              groupProps={{
                className: 'row col-12 order-create-content',
              }}
              type="select"
              inputProps={{
                width: '63%',
                multiple: false,
                items: statusItems,
              }}
              onChange={onChange('status')}
              disabled={mode === MODE.EDIT}
              value={order?.status || ''}
              className="form-control m-input"
            />
          </>
        ) : null}
        {mode !== MODE.EDIT && !isSubscription && (
          <FormInput
            type="users"
            id="users"
            name="users"
            labelClassName="col-lg-2 col-12 label-customer text-right"
            containerClassName="col-lg-8 col-12 row no-gutters customer-info-correct-mobile"
            label={t('order_customer')}
            placeholder={t('order_customer_placeholder')}
            groupProps={{
              className:
                'row col-12 order-create-content order-create-content-seller',
            }}
            onChange={onChange('seller')}
            value={order?.seller || ''}
            width="100%"
            className="form-control m-input"
            inputProps={{
              showFilter: true,
              multiple: false,
              userTypeNames,
              // onUnselect: onUnselectUser(field),
              allowClear: false,
              showAddNewUser: true,
              onCloseAddUser,
              languages,
              url: '/user/table/network/list?includeMe=true&showInvited=true',
              filterUrl:
                '/table/user/network/list?includeMe=true&showInvited=true',
            }}
          />
        )}
      </div>
      {order?.seller?._id && (
        <div className="customer-info justify-content-center">
          <CustomerInfo
            onShippingChange={onShippingChange('shippingAddress')}
            user={order.seller}
            shippingAddressIsDifferent={isShippingAddressDifferent}
            handleDifferentShippingAddress={onDifferentShippingAddress}
            isOnlyDigitalProducts={isOnlyDigitalProducts}
            onAddressOpen={onAddressOpen}
          />
        </div>
      )}
    </div>
  );
}

CustomerSection.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onShippingChange: PropTypes.func.isRequired,
  onDifferentShippingAddress: PropTypes.func.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
  isShippingAddressDifferent: PropTypes.bool.isRequired,
  isOnlyDigitalProducts: PropTypes.bool.isRequired,
  onCloseAddUser: PropTypes.func.isRequired,
  userTypeNames: PropTypes.shape({
    [PropTypes.string]: PropTypes.string,
  }),
  onAddressOpen: PropTypes.func.isRequired,
  isOpportunity: PropTypes.bool,
  languages: PropTypes.shape(CountryProp.propType).isRequired,
  mode: PropTypes.string,
  isSubscription: PropTypes.bool,
};

CustomerSection.defaultProps = {
  userTypeNames: {},
  isOpportunity: false,
  mode: MODE.CREATE,
  isSubscription: false,
};

export default translate(CustomerSection);
